import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateUserRequestBody,
  IApiUpdateUserResponseBody,
} from '../UsersApi.types';
import { useApi } from '~/lib/api/useApi';
import { userQueryKeyFactory } from './useUserQuery';

export type IUseUpdateUserMutationValues = {
  userId: string;
  body: IApiUpdateUserRequestBody;
};

export const useUpdateUserMutation = (): UseMutationResult<
  IApiUpdateUserResponseBody,
  unknown,
  IUseUpdateUserMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.users.update(values.userId, values.body),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return the updated user, update the
      // query data
      // queryClient.setQueryData(
      //   userQueryKeyFactory({
      //     userId: updatedUser._id,
      //   }),
      //   updatedUser,
      // );

      // In the meantime:
      await queryClient.invalidateQueries({
        queryKey: userQueryKeyFactory(values),
      });
    },
  });
};
